import React, { FC, PropsWithChildren } from 'react';
import AuthorizationHeader from '@/features/identity/components/AuthorizationHeader.tsx';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@/hooks/useMediaQuery.ts';
import { AppConfig } from '@/config/app.config.ts';
import { cn } from '@/lib/utils';

const IdentityPageLayout: FC<PropsWithChildren> = ({ children }) => {
	const { t } = useTranslation();
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	return (
		<>
			<section className='relative h-dvh flex flex-1 overflow-hidden'>
				<AuthorizationHeader />
				{!isMobile && (
					<div className='relative w-1/2 p-8 flex flex-col justify-center gap-4 bg-popover-1000 '>
						<div className='absolute inset-0 bg-[url("/main-bg.png")] bg-no-repeat' />
						<h2 className='text-4xl font-semibold text-popover-10'>
							{t('auth.main.title')}
						</h2>
						<p className='text-xl font-normal text-popover-50'>
							{t('auth.main.subtitle')}
						</p>
					</div>
				)}
				<div
					className={cn(
						'w-1/2 flex-1 flex items-center justify-center relative',
						isMobile && 'w-full p-4 mt-19 overflow-y-scroll',
					)}>
					{children}
					<p className="absolute bottom-4 left-0 right-0 text-center text-xs text-popover-400">
						v {AppConfig.defaults.version}
					</p>
				</div>
			</section>
		</>
	);
};

export default IdentityPageLayout;
